// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths
import PackageJson from "../../package.json"
import {type Environment} from "@environment/types"

/**
 * Configuration for preview deployments (i.e. all deployments to non-prod environments).
 */
export const environment: Environment = {
    production: true,
    name: "dev4",
    version: PackageJson.version,

    auth: {
        google: {
            clientId: "608675176242-9a7778mmllu4026o5m3ehi2n58vir03n.apps.googleusercontent.com",
        },
        microsoft: {
            clientId: "151d8cd7-eff9-441e-b8b9-1072287949cb",
        },
    },

    firebase: {
        apiKey: "AIzaSyBnog-h4phjBVh39evmoQFRIN6hbnw8jpg",
        authDomain: "cm-platform-dev4.firebaseapp.com",
        projectId: "cm-platform-dev4",
        storageBucket: "cm-platform-dev4.firebasestorage.app",
        messagingSenderId: "442630783384",
        appId: "1:442630783384:web:f45105095711b51d04ebed",
    },
    firebaseConfig: {
        collectionEnabled: true,
    },

    rendering: {
        materialAssets: {
            fallbackTemplateId: 17484,
            samples: 64,
        },
        shaderBall: {
            templateId: 17482,
        },
        defaultQueueDomain: "colormass",
        maxConcurrentRenderJobs: 200,
    },

    storage: {
        bucketsPrefix: "cm-platform-dev4-",
        usePostToUpload: false,
    },

    style: {
        application: {
            background: "#991b1b40",
            label: "dev4",
        },
    },

    debug: {
        enableCallStack: false,
    },

    onboarding: {
        allowSkipPayment: false,
    },

    stripe: {
        fullyIntegrated: false,
    },

    configuratorUrl: "https://configurator-dev4.colormass.com?apiVersion=2",
    platformDeployUrl: "https://dev4.colormass.com",
    configuratorDeployUrl: "https://configurator-dev4.colormass.com",
    gqlApiEndpoint: "https://gql-dev4.colormass.com",
    jobsInstanceUrl: "https://jobs-dev4.colormass.com",
    localTilingEndpoint: "ws://localhost:5678/",

    defaultRenderQueueDomain: "render",
}
